import c_1_1 from "../../assets/sound-conversation/c_1_1.mp3"
import c_1_2 from "../../assets/sound-conversation/c_1_2.mp3"

export const audio1 = [
  { 'id':1,
    'text':'-Chào anh! Xin lỗi anh tên là gì?\n-Chào em! tên tôi là David, còn em, tên em là gì?\n-Tên em là Lính.\n-Rất vui được gặp em!\n-Em cũng rất vui được gặp anh!',
    'audio': c_1_1,
  },

];

export const audio1_1 = [
  { 'id':1,
    'text':'-Chào chị! Tên chị là gì?\n-Tên tôi là Mary.\n-Chỉ là người nước nào?\n-Tôi là người Mỹ, còn em?\n-Em là ngã người Việt Nam.\n-Rất vui được gặp em!\n-Rất vui được gặp chị!',
    'audio': c_1_2,
  }
];